function splitAddress(address) {
  const parts = {
    prefecture: '',
    city: '',
    rest: ''
  };

  // 例：東京都、大阪市、愛知県、京都府などの都道府県名（一部省略可能）
  const prefectureMatch = address.match(/^(北海道|青森県|岩手県|宮城県|秋田県|山形県|福島県|茨城県|栃木県|群馬県|埼玉県|千葉県|東京都|神奈川県|新潟県|富山県|石川県|福井県|山梨県|長野県|岐阜県|静岡県|愛知県|三重県|滋賀県|京都府|大阪府|兵庫県|奈良県|和歌山県|鳥取県|島根県|岡山県|広島県|山口県|徳島県|香川県|愛媛県|高知県|福岡県|佐賀県|長崎県|熊本県|大分県|宮崎県|鹿児島県|沖縄県)(.*)/) || [];

  if (prefectureMatch.length > 1) {
    parts.prefecture = prefectureMatch[1]; // 都道府県名
    const remaining = prefectureMatch[2]; // 都道府県名以降

    // 例：○○市、○○区、○○村の市区町村名
    const cityMatch = remaining.match(/^(.*?(?:市|区|町|村|郡))(.*)/) || [];

    if (cityMatch.length > 1) {
      parts.city = cityMatch[1]; // 市区町村名
      parts.rest = cityMatch[2]; // それ以降の住所
    } else {
      parts.rest = remaining; // 市区町村名がない場合
    }
  } else {
    // 都道府県名が省略されている場合など（政令指定都市など）
    // 都道府県名がないと判断されるケースでは、都市名や地域名が市区町村名になる
    const firstPartMatch = address.match(/^(.*?)(?:区|市|町|村)(.*)/) || [];
    if (firstPartMatch.length > 1) {
        parts.city = firstPartMatch[1];
        parts.rest = firstPartMatch[2];
    } else {
        parts.rest = address; // 全て「それ以降」に格納
    }
  }

  return parts;
}

module.exports = {
  splitAddress,
};
